import { createSlice } from '@reduxjs/toolkit';
import { FULLFILLED } from '@root/constants';
import { FETCH_CURRENCIES, FETCH_FAQS, FETCH_FEATURES, FETCH_NOTIFICATION, FETCH_SUGGESTED_QUESTION } from '@root/store/action-types';


const INITIAL_STATE: IAppEntities = {
  todayQuestions: [],
  chatsDropsdown:false,
  notificationContent:[],
  currencies:[],
  faqs:{},
  selectedPlan:{},
  features:{},
};

export const appEntitySlice = createSlice({
  name: 'app',
  initialState: INITIAL_STATE,
  reducers: {
    resetAppEntitiesData: (state) => {
      state.todayQuestions = null;
    },
    updateChatsDropdownStatus: (state, action) => {
      state.chatsDropsdown = action.payload
    },
    updateSelectedPlan: (state, action) => {
      state.selectedPlan = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(`${FETCH_SUGGESTED_QUESTION}${FULLFILLED}`, (state, action: any) => {
      state.todayQuestions = action.payload;
    });
    builder.addCase(`${FETCH_NOTIFICATION}${FULLFILLED}`, (state, action: any) => {
      state.notificationContent = action.payload;
    });
    builder.addCase(`${FETCH_CURRENCIES}${FULLFILLED}`, (state, action: any) => {
      state.currencies = action.payload;
    });
    builder.addCase(`${FETCH_FAQS}${FULLFILLED}`, (state, action: any) => {
      state.faqs = action.payload;
    });
    builder.addCase(`${FETCH_FEATURES}${FULLFILLED}`, (state, action: any) => {
      state.features = action.payload;
    });
  },
});

export const {
  resetAppEntitiesData,
  updateChatsDropdownStatus,
  updateSelectedPlan
} = appEntitySlice.actions;

export const appEntityReducer = appEntitySlice.reducer;
